/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState } from 'react';
import classNames from 'classnames/bind';

import If from '@components/shared/conditional/If/If';
import PlusIcon from '@components/shared/images/atoms/PlusIcon/PlusIcon';
import { useTheme } from '@components/theme';
import InsploreBoardIcon from './insploreBoard.svg';
import ProjectsIcon from './projectsIcon.svg';

import styles from './CreateButton.module.scss';

const cx = classNames.bind(styles);

const CreateButton = (props) => {
  const {
    openCreateBoard,
    openNewProject,
    isHidden = false,
  } = props;

  const [isExpanded, setIsExpanded] = useState(false);
  const theme = useTheme();

  const handleDesignProjectClick = () => {
    setIsExpanded(false);

    openNewProject(true);
  };

  const handleInsploreBoardClick = () => {
    setIsExpanded(false);

    openCreateBoard();
  };

  return (
    <div
      className={ cx({
        Wrapper: true,
        isHidden,
      })}
    >
      <If condition={ isExpanded }>
        <div
          className={ styles.Overlay }
          onClick={ () => setIsExpanded(false) }
        />
        <div className={ styles.SecondaryButtonWrapper }>
          <span className={ styles.SecondaryButtonTextMobile }>
            Design Project
          </span>
          <button
            className={ styles.SecondaryButton }
            onClick={ handleDesignProjectClick }
            type="button"
          >
            <span
              className={ styles.SecondaryIcon }
            >
              <ProjectsIcon />
            </span>
            <span className={ styles.SecondaryButtonTextDesktop }>
              Design Project
            </span>
          </button>
        </div>

        <div className={ styles.SecondaryButtonWrapper }>
          <span className={ styles.SecondaryButtonTextMobile }>
            Inspiration Board
          </span>
          <button
            className={ styles.SecondaryButton }
            onClick={ handleInsploreBoardClick }
            type="button"
          >
            <span
              className={ styles.SecondaryIcon }
            >
              <InsploreBoardIcon />
            </span>
            <span className={ styles.SecondaryButtonTextDesktop }>
              Inspiration Board
            </span>
          </button>
        </div>
      </If>

      <button
        className={classNames(styles.PrimaryButton, theme.styles.Button)}
        onClick={ () => setIsExpanded(!isExpanded) }
        type="button"
      >
        <span
          className={ styles.PlusIcon }
        >
          <PlusIcon />
        </span>
        <span className={ styles.ButtonText }>CREATE BOARD</span>
      </button>
    </div>
  );
};

export default CreateButton;
